module.exports = __webpack_public_path__ + "media/images/writer/follow_up_mailer/video_4-08d5484176dfb1afc74c36da46b9c517.png";